/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function (Drupal, $) {
  'use strict';

  // To understand behaviors, see https://www.drupal.org/node/2269515
  Drupal.behaviors.idspTheme = {
    attach: function (context, settings) {
      var self = this;

      $('.swiper').once('theme-process').each(function () {
        const swiper = new Swiper('.swiper', {
          direction: 'horizontal',
          speed: 500,
          loop: true,
          autoplay: {
            delay: 4000
          },
          pagination: {
            el: '.swiper-pagination',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          scrollbar: {
            el: '.swiper-scrollbar',
          },
        });

        self.sliderPause(swiper);
      });
    },
    sliderPause: function (swiper) {
      const swiperPause = swiper.el.getElementsByClassName('swiper-button-pause');

      if (swiperPause.length) {
        var pause = swiperPause[0];

        pause.addEventListener('click', function (e) {
          if (swiper.autoplay.running) {
            swiper.autoplay.stop();
            pause.classList.add('active');
          }
          else {
            swiper.autoplay.start();
            pause.classList.remove('active');
          }
        });
      }
    },
    openTab: function (evt, cityName) {
      var i, tabcontent, tablinks;

      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    }
  };
})(Drupal, jQuery);
